import { BaseService } from '../base';
import type { ProductEmissionMode, ProductSettings } from './types';

export type { ProductEmissionMode, ProductSettings } from './types';

class ProductSettingsService extends BaseService {
  private readonly customBaseUrl: string;

  constructor() {
    super();
    this.customBaseUrl = import.meta.env.VITE_API_URL;
  }

  /**
   * Retorna apenas os produtos que TÊM configuração gravada no BFF. Produto
   * ausente da lista se comporta como `INTEGRATION` — quem consome cruza com o
   * registry de produtos do front e assume esse padrão.
   */
  async listProductSettings(): Promise<{
    success: boolean;
    data?: ProductSettings[];
    error?: string;
  }> {
    const response = await this.get(
      '/portal/v1/products/settings',
      {},
      this.customBaseUrl
    );
    return this.handleJsonResponse<ProductSettings[]>(response);
  }

  /**
   * Altera o modo de emissão de um produto. NÃO lança em erro de negócio —
   * devolve o envelope para a tela mostrar a mensagem sem perder o estado.
   */
  async updateEmissionMode(
    productCode: string,
    emissionMode: ProductEmissionMode
  ): Promise<{ success: boolean; data?: ProductSettings; error?: string }> {
    const response = await this.put(
      `/portal/v1/products/${encodeURIComponent(productCode)}/settings/emission-mode`,
      { emissionMode },
      this.customBaseUrl
    );
    return this.handleJsonResponse<ProductSettings>(response);
  }
}

export const productSettingsService = new ProductSettingsService();
